import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Tooltip,
  Checkbox,
  FormHeading
} from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

import { useButtons } from '../../../../hooks/index';
import ExpiresTooltip from '../../../ExpiresTooltip';

const LocationInput = ({
  content,
  index,
  rtl = 'ltr'
}) => {
  const { handleButtonChange } = useButtons();

  return (
    <Flex col ySpace fat>
      <FormHeading>Location</FormHeading>
      <TemplatingTextInput
        rtl={rtl}
        aria-label={`location-label-${index + 1}`}
        value={content.label}
        placeholder="Send Location"
        onChange={value => {
          handleButtonChange(index, 'label', value);
        }}
      />
      <Flex center>
        <TemplatingTextInput
          rtl={rtl}
          aria-label={`location-action-${index + 1}`}
          value={content.action}
          placeholder="The user shared the location button"
          onChange={value => {
            handleButtonChange(index, 'action', value);
          }}
        />
        <Tooltip
          position={Tooltip.POSITIONS.TOP}
          tooltip={
            <Tooltip.Content>
              This optional postback text can be used to trigger a new step when
              the user clicks the button to perform an action.
            </Tooltip.Content>
          }
        >
          <Tooltip.Icon>?</Tooltip.Icon>
        </Tooltip>
      </Flex>
      <Flex>
        <Checkbox
          aria-label={`location-expires-${index + 1}`}
          checked={content.action ? content.expires : false}
          disabled={!content.action}
          onChange={() => {
            handleButtonChange(index, 'expires', !content.expires);
          }}
          label="Disable on reply"
        />
        <ExpiresTooltip />
      </Flex>
    </Flex>
  );
};

LocationInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr']),
  content: {
    label: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    linkback: PropTypes.string.isRequired,
    expires: PropTypes.bool
  },
  index: PropTypes.number.isRequired
};

export default LocationInput;
